// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"ecb14388","498":"f633229b","703":"6a398ac1"}[chunkId] + ".chunk.js";
};